module.exports = __webpack_public_path__ + "img/backarw.ad5d178a.svg";